import { AuthenticationContextType } from '@climatepartner/app-shell';

import { AuthUser, AuthUserType } from '../ports/auth';

export class FronteggAuthUser implements AuthUser {
    constructor(private readonly context: AuthenticationContextType) {}

    get id(): string {
        return this.context.user.id;
    }
    get name(): string {
        return this.context.user.name;
    }
    get email(): string {
        return this.context.user.email;
    }
    get url(): string {
        return `https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserProfileMenuBlade/~/overview/userId/${this.id}/hidePreviewBanner~/true`;
    }
    get type(): AuthUserType {
        return this.isAdmin() ? 'admin' : 'user';
    }

    isAdmin(): boolean {
        return this.context.actions.hasPermission('ecopilot.admin.access');
    }

    async accessToken(): Promise<string> {
        return this.context.user.accessToken;
    }
}
